import { render } from "./SubMenu.vue?vue&type=template&id=0737ba18&scoped=true"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"

import "./SubMenu.vue?vue&type=style&index=0&id=0737ba18&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0737ba18"]])

export default __exports__